import TeamContainer from "./TeamContainer";

export default TeamContainer;
